import { InjectionToken } from "@angular/core";

export const ICONS_PATH = new InjectionToken<string>('../../../../assets/vinter/icons');
